import { Dispatch, SetStateAction } from 'react';
import type { ScrollEvent } from './_props';

const onScrolFn = (e: ScrollEvent, setScrollTop: Dispatch<SetStateAction<number>>) => {
  setScrollTop(e.currentTarget.scrollTop);
};

export default onScrolFn;
